// import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// interface Vendor {
//   id: string;
//   storeName: string;
//   email: string;
//   address1: string;
//   country: string;
//   city: string;
//   state: string;
//   storePhone: string;
//   craftCategories: string[];
// }

// // Define the state type
// interface VendorState {
//   vendor: Vendor | null;
//   token: string | null;
// }

// const initialState: VendorState = {
//   vendor: null,
//   token: null,
// };

// const vendorSlice = createSlice({
//   name: "vendor",
//   initialState,
//   reducers: {
//     setVendor: (
//       state,
//       action: PayloadAction<{ vendor: Vendor; token: string }>
//     ) => {
//       state.vendor = action.payload.vendor;
//       state.token = action.payload.token;
//     },
//     logoutVendor: (state) => {
//       state.vendor = null;
//       state.token = null;
//     },
//   },
// });

// export const { setVendor, logoutVendor } = vendorSlice.actions;
// export default vendorSlice.reducer;
// src/redux/slices/vendorSlice.ts

import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type { SupportMessage } from "@/components/CustomerSupport/supportMessages";

interface Vendor {
  _id: string;
  storeName: string;
  email: string;
  storePhone: string;
  storeType: string;
  avatar: string;
  businessLogo: string;
  bankAccount: {
    account_number: string;
    bank_code: string;
    bankName: string;
    account_name: string;
  };
  communities: string[];
  communityPosts: Array<{ [key: string]: any }>;
  craftCategories: string[];
  createdAt: string;
  emailSent: boolean;
  followers: Array<{ [key: string]: any }>;
  following: Array<{ [key: string]: any }>;
  my_bought_products_orders: string[];
  notifications: any[];
  orders: string[];
  otpCode: string;
  otpExpires: string;
  paystackRecipientCode: string;
  products: string[];
  returnPolicy?: string;
  verificationStatus: string;
  kycStatus: "Pending" | "Approved" | "Rejected" | "Processing"; // Example statuses
  __v: number;
}

export type Message = SupportMessage;

interface VendorState {
  vendor: Vendor | null;
  token: string | null;
  refreshToken: string | null;
  customerCareChatId: string | null;
  customerCareMessages: Message[];
}

const initialState: VendorState = {
  vendor: null,
  token: null,
  refreshToken: null,
  customerCareChatId: null,
  customerCareMessages: [],
};

const vendorSlice = createSlice({
  name: "vendor",
  initialState,
  reducers: {
    setVendor: (
      state,
      action: PayloadAction<{ vendor: Vendor; token: string; refreshToken: string | null }>
    ) => {
      if (state.vendor?._id !== action.payload.vendor._id) {
        state.customerCareChatId = null;
        state.customerCareMessages = [];
      }
      state.vendor = action.payload.vendor;
      state.token = action.payload.token;
      state.refreshToken = action.payload.refreshToken;
      state.customerCareMessages = state.customerCareMessages || [];
    },
    setVendorTokens: (
      state,
      action: PayloadAction<{ accessToken: string; refreshToken: string }>
    ) => {
      state.token = action.payload.accessToken;
      state.refreshToken = action.payload.refreshToken;
    },
    updateKycVendor: (
      state,
      action: PayloadAction<"Pending" | "Approved" | "Rejected" | "Processing">
    ) => {
      if (state.vendor) {
        state.vendor.kycStatus = action.payload;
      }
    },
    setCustomerCareChatId: (state, action: PayloadAction<string | null>) => {
      state.customerCareChatId = action.payload;
    },
    setCustomerCareMessages: (state, action: PayloadAction<Message[]>) => {
      state.customerCareMessages = action.payload || [];
    },
    addCustomerCareMessage: (state, action: PayloadAction<Message>) => {
      state.customerCareMessages = state.customerCareMessages || [];
      state.customerCareMessages.push(action.payload);
    },
    logoutVendor: (state) => {
      state.vendor = null;
      state.token = null;
      state.refreshToken = null;
      state.customerCareChatId = null;
      state.customerCareMessages = [];
    },
  },
});

export const {
  setVendor,
  setVendorTokens,
  logoutVendor,
  addCustomerCareMessage,
  setCustomerCareMessages,
  setCustomerCareChatId,
  updateKycVendor,
} = vendorSlice.actions;

export default vendorSlice.reducer;
